import get from 'lodash/get'
import uniqBy from 'lodash/uniqBy'

import { defaultSelectedTab } from '../../constants/constants'

import {
  LISTINGS_HAS_ERRORED,
  LISTINGS_IS_LOADING,
  LISTINGS_FETCH_DATA_SUCCESS,
  LISTINGS_LOAD_MORE_SUCCESS,
  DISPLAY_INFINITE_SCROLL_LOAD_MORE,
  LISTINGS_LOADING_MESSAGE,
  FETCHED_INITIAL_LISTINGS,
  SET_EXPIRED_SESSION_TIMESTAMP,
  UPDATE_BRAND_REFERENCE,
  UPDATE_ACTIVE_TAB_ID
} from '../../actions/actionTypes'

export function listingsHasErrored(state = false, action) {
  switch (action.type) {
    case LISTINGS_HAS_ERRORED:
      return action.hasErrored
    default:
      return state
  }
}

export function listingsIsLoading(state = true, action) {
  switch (action.type) {
    case LISTINGS_IS_LOADING:
      return action.isLoading
    default:
      return state
  }
}

export function listingsLoadingMessage(state = '', action) {
  switch (action.type) {
    case LISTINGS_LOADING_MESSAGE:
      return action.message
    default:
      return state
  }
}

export function displayInfiniteScrollLoadMore(state = true, action) {
  switch (action.type) {
    case DISPLAY_INFINITE_SCROLL_LOAD_MORE:
      return action.bool
    default:
      return state
  }
}

export function brandReference(state = [], action) {
  switch (action.type) {
    case UPDATE_BRAND_REFERENCE:
      return uniqBy([...state, ...action.brandReference], 'brandId')
    default:
      return state
  }
}

export function fetchedInitialListings(state = false, action) {
  switch (action.type) {
    case FETCHED_INITIAL_LISTINGS:
      return action.bool
    default:
      return state
  }
}

export const activeTabId = (state = defaultSelectedTab, action) => {
  switch (action.type) {
    case UPDATE_ACTIVE_TAB_ID:
      return action.activeTabId
    default:
      return state
  }
}

export function listings(state = {}, action) {
  switch (action.type) {
    case LISTINGS_FETCH_DATA_SUCCESS:
      return Object.assign({}, state, {
        lastUpdateTime: new Date().getTime(),
        response: get(action, 'listings.response'),
        voidWindowInfo: get(action, 'listings.minVoidWindowClose'),
        isAirCanada: get(action, 'listings.isAirCanada')
      })
    case LISTINGS_LOAD_MORE_SUCCESS:
      // TODO eventually we'll want to append the new data to listings
      return Object.assign({}, state, {
        lastUpdateTime: new Date().getTime(),
        response: get(action, 'listings.response') || state.response
      })
    case SET_EXPIRED_SESSION_TIMESTAMP:
      return Object.assign({}, state, {
        expiredSessionTimestamp: new Date().getTime()
      })
    default:
      return state
  }
}
